/**
 * Shared auth helper for Sales Portal pages.
 * Uses HttpOnly cookies for authentication — no tokens in JavaScript.
 * Provides user context via /auth/me endpoint.
 */
const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Standard fetch options with credentials for HttpOnly cookies.
 */
export function getSalesHeaders() {
  return { 'Content-Type': 'application/json' };
}

/**
 * Backward compatibility alias.
 */
export function getSalesToken() {
  return '';
}

/**
 * Fetch wrapper that includes credentials (HttpOnly cookies).
 */
export function authFetch(url, options = {}) {
  return fetch(url, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
}

/**
 * Check if user is authenticated by calling /auth/me.
 * Returns user object or null.
 */
export async function checkAuth() {
  try {
    const res = await fetch(`${API}/api/sales/auth/me`, {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    if (res.ok) return await res.json();
    return null;
  } catch {
    return null;
  }
}

/**
 * Check if admin is authenticated.
 */
export async function checkAdminAuth() {
  try {
    const res = await fetch(`${API}/api/admin/me`, {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    if (res.ok) return await res.json();
    return null;
  } catch {
    return null;
  }
}

/**
 * Log out (clears HttpOnly cookie server-side).
 */
export async function salesLogout(navigate) {
  try {
    await fetch(`${API}/api/sales/auth/logout`, {
      method: 'POST',
      credentials: 'include',
    });
  } catch { /* ignore */ }
  navigate('/sales/login');
}

export async function adminLogout(navigate) {
  try {
    await fetch(`${API}/api/admin/logout`, {
      method: 'POST',
      credentials: 'include',
    });
  } catch { /* ignore */ }
  navigate('/admin/login');
}
